module.exports = __webpack_public_path__ + "static/media/map-provinces-simulation.b25e8608.svg";